import { translateWord } from './translateWord';

import type { Options } from './interface';

export function translate(original: string, options?: Partial<Options>): string {
  return original.replace(/[a-z]+-?/gi, (word) => translateWord(word, options));
}
